import { useEffect, useState, useRef } from "react";

const useCarouselNavigation = ({ carouselItems, selectedTab, setSelectedTab, onDropdownSelectionChange, initialIndex = 0 }) => {
    //type comes from TAB_ENUM
    const [selectedIndex, setSelectedIndex] = useState(initialIndex);
    const [totalItems, setTotalItems] = useState(0);
    const [skipAnimation, setSkipAnimation] = useState(false);

    //set skipAnimation to true if initialIndex is not 0
    useEffect(() => {
        if (initialIndex !== 0) {
            setSkipAnimation(true);
        }
    }, [initialIndex]);

    useEffect(() => {
        setSelectedIndex(initialIndex);
        setTotalItems(carouselItems?.length);
    }, [carouselItems, initialIndex]);
    
    const handleSelectThumbnail = (index, type) => {
        setSelectedTab(type);
        setSelectedIndex(index);
        setSkipAnimation(true);
        if (window.parent) {
            window.parent.postMessage(
                { 
                    type: 'ITEM_SELECTED', 
                    selectedIndex: index, 
                    selectedTab: type 
                },
                '*'
            );
        }
        const selectedItem = carouselItems[index];
        if (selectedItem?.type === "threeSixty") {
        onDropdownSelectionChange && onDropdownSelectionChange("EXT");
        } else if (selectedItem?.type === "360Int") {
        onDropdownSelectionChange && onDropdownSelectionChange("INT");
        }else{
            onDropdownSelectionChange && onDropdownSelectionChange("EXT");
        }
    }

    const handleLeftRef = useRef(() => { });
    const handleRightRef = useRef(() => { });

    useEffect(() => {
        handleLeftRef.current = (totalItems, selectedIndex) => {
            if (totalItems > 0) {
                let newIndex = (selectedIndex - 1 + totalItems) % totalItems;
                // On mobile, prevent wrapping to 360Int
                if (window.innerWidth < 424) {
                    const nextItem = carouselItems[newIndex];
                    if (nextItem?.type === "360Int") {
                        return; // Don't navigate if it would go to 360Int on mobile
                    }
                }
                setSelectedIndex(newIndex);
                setSelectedTab(carouselItems[newIndex]?.type);
                setSkipAnimation(false);
            }
        }

        handleRightRef.current = (totalItems, selectedIndex) => {
            if (totalItems > 0) {
                let newIndex = (selectedIndex + 1) % totalItems;
                setSelectedIndex(newIndex);
                setSelectedTab(carouselItems[newIndex]?.type);
                setSkipAnimation(false);
            }
        };
    }, [carouselItems, selectedIndex, totalItems, handleLeftRef, handleRightRef]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') {
                handleLeftRef.current(totalItems, selectedIndex);
            } else if (e.key === 'ArrowRight') {
                handleRightRef.current(totalItems, selectedIndex);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [selectedIndex, totalItems, handleLeftRef, handleRightRef]);


    return {
        selectedIndex,
        handleLeft: handleLeftRef.current,
        handleRight: handleRightRef.current,
        handleSelectThumbnail,
        skipAnimation
    }
};

export default useCarouselNavigation;